import supabase from "artifact/supabase";
import connected from "standard/connected";
import define from "standard/define";
import filter from "standard/filter";
import on from "standard/on";
import paint from "standard/paint";
import trait from "standard/trait";
import willPaint from "standard/willPaint";
import style from "./style";

@define("m-profile")
class Profile extends HTMLElement {
  #user;

  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }

  @connected
  @paint
  [trait.template]() {
    return `
      <form class=${style.profile__form}>
        <m-name value="${this.#user.name}"></m-name>
        <m-email value="${this.#user.email}"></m-email>
        <m-new-password></m-new-password>
        <button class=${style.profile__save}>Salvar</button>
      </form>
    `;
  }

  @on.submit("form")
  @filter.prevent
  @filter.validity
  @filter.formData
  async [trait.save](formData) {
    const { email, name, password } = formData;
    await supabase.auth.updateUser({ email, data: { name } });
    password && (await supabase.auth.updateUser({ password }));
    await supabase
      .from("user")
      .update({ email, name })
      .eq("id", this.dataset.user);
    alert("Seus dados foram salvo com sucesso!");
    return this;
  }

  @willPaint
  async [trait.fetch]() {
    const {
      data: [user],
    } = await supabase
      .from("user")
      .select("*")
      .eq("id", this.dataset.user)
      .limit(1);
    this.#user = user;
    return this;
  }
}

export default Profile;
